import React, { useCallback, useEffect, useMemo, useState } from 'react'
import BetList from './BetList'
import { pagecount } from '../../../../utils/reuse';
import { alertPlatform } from '../../../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../../../../layouts/Layout';

export default function BetListByEvent() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [betList, setBetList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(pagecount + 1);
    const [last, setLast] = useState(true);
    const [paging, setPaging] = useState(false);
    const [sortField, setSortField] = useState('reportdate');
    const [sortOrder, setSortOrder] = useState(-1);
    const [requestType, setRequestType] = useState('single');
    const { state } = useLocation();
    const [backNavigation]= useState({ url: `anomalies`, name: 'Anomalies'});
    const sessionData = useSelector((state) => state.auth.sessionData);
    const headers = useMemo(() => {
        return { sessionid: sessionData.sessionId };
    }, [sessionData.sessionId]);
    const getBetList = useCallback((data) => {
        setLoading(true);
        const params = {
            offset: offset,
            limit: limit,
            sort_by: sortField,
            sort_order: sortOrder === -1 ? 'desc' : 'asc'
        };
        if (requestType) {
            params.groupBy = requestType;
        }

        alertPlatform('betlist', params, data, headers, dispatch, (response) => {
            if (response.result === "SUCCESS") {
                const responseData = response.data;
                const result = responseData?.length > 0 ? responseData.slice(0, pagecount) : [];
                if (result.length > 0) {
                    setLast(responseData.length <= pagecount);
                    setPaging(true);
                    setBetList(result);
                } else {
                    setLast(true);
                    setPaging(false);
                    setBetList([]);
                }
            } else {
                setLast(true);
                setPaging(false);
                setBetList([]);
            }
            setLoading(false);
        });
    }, [dispatch, headers, limit, offset, requestType, sortField, sortOrder]);
     useEffect(() => {
        if (state?.searchRequest && state?.searchRequest?.groupID && state?.searchRequest?.stateID) {
          getBetList(state.searchRequest);
        } else {
         navigate('/anomalies')
        }
      }, [getBetList, navigate, state]);
    const handlePageChange = (currentPage) => {
        setPaging(false);
        setPage(currentPage);
        const offsetVal = (currentPage - 1) * pagecount;
        const limitVal = pagecount + 1;
        setOffset(offsetVal);
        setLimit(limitVal);
        setLoading(true);
    };
    const sortHandler = ({ sortField, sortOrder }) => {
        setSortField(sortField);
        setSortOrder(sortOrder);
        handlePageChange(1);
    }
    const onTabChangeHandler = (type) => {
        setRequestType(type)
        setPage(1);
        setOffset(0);
        setLoading(true)
    }
    return (
        <section className="analyst-home-section statistics-betting-section">
            <Layout backBtn={backNavigation.url} backBtnLabel={backNavigation.name}>
            <section className="best-list-section">
                <div className="flex align-items-center justify-content-between">
                    <h2 className='heading-h2'>Event Bet List - {state?.event}</h2>
                </div>
                <BetList betList={betList} loading={loading} page={page} paging={paging} last={last} sortField={sortField} sortOrder={sortOrder} handlePageChange={handlePageChange} sortHandler={sortHandler} onTabChange={onTabChangeHandler} type={'anomalies'} groupId={state?.searchRequest?.groupID}/>
            </section>
            </Layout>
        </section>
    )
}
